import { render, staticRenderFns } from "./LoteFormalizacao.vue?vue&type=template&id=e03cbae6"
import script from "./LoteFormalizacao.vue?vue&type=script&lang=js"
export * from "./LoteFormalizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports